<template>
  <div class="page-careers py-3">
    <a href="/" id="go-back">
      <font-awesome-icon icon="chevron-left" class="fas"></font-awesome-icon>
      <span>Înapoi</span>
    </a>
    <div class="container">
      <div class="page-inner p-3">
        <p
          class="intro mb-4"
        >Diafanis Com SRL(Acoperis Expert) este furnizor de produse și soluții în domeniul sistemelor de învelitori pentru acoperisuri, Wetterbest, Ruukki . Suntem pe piata din anul 2010 și ne bucurăm de o creștere continuă a vânzărilor și a încrederii, atât din partea clienților cât și a furnizorilor.</p>
        <h2>Angajăm reprezentant vânzări.</h2>
        <p
          class="mb-4"
        >Acest serviciu presupune deplasarea în teren pentru identificarea șantierelor în lucru, respectiv potențialilor clienți.</p>
        <div class="row mb-4">
          <div class="col-lg-4">
            <div class="unit mb-3 mb-lg-0">
              <h3
                class="mb-4 d-flex align-items-center justify-content-center justify-content-md-start"
              >
                <span class="mr-2">1</span> Responsabilități:
              </h3>
              <ul>
                <li>Identificarea potențialilor clienți;</li>
                <li>Promovarea produselor și serviciilor companiei;</li>
                <li>Vânzarea soluțiilor, serviciilor și produselor companiei pentru realizarea țintelor propuse;</li>
                <li>Consilierea clienților pentru alegerea deciziei optime;</li>
                <li>Întocmirea ofertelor comerciale și economice în forma scrisă;</li>
                <li>Oferă suport post vânzare;</li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="unit mb-3 mb-lg-0">
              <h3
                class="mb-4 d-flex align-items-center justify-content-center justify-content-md-start"
              >
                <span class="mr-2">2</span>Candidatul ideal:
              </h3>
              <ul>
                <li>Experiență în vânzarea sau ofertarea de materiale pentru acoperișuri;</li>
                <li>Abilități de comunicare, vânzare și negociere;</li>
                <li>Înclinare către îndeplinirea obiectivelor propuse;</li>
                <li>Vânzarea soluțiilor, serviciilor și produselor companiei pentru realizarea țintelor propuse;</li>
                <li>Sociabilitate, atitudine pozitivă și optimistă, încredere, inițiativă și perseverență;</li>
                <li>Cunoștințe operare PC;</li>
              </ul>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="unit mb-3 mb-lg-0">
              <h3
                class="mb-4 d-flex align-items-center justify-content-center justify-content-md-start"
              >
                <span class="mr-2">3</span>Oferta:
              </h3>
              <ul>
                <li>Salar fix + comision în funcție de realizări;</li>
                <li>Lucru într-o companie dinamică cu o flexibilitate bună față de echipă;</li>
                <li>Cursuri de specialitate și pregătire continuă;</li>
                <li>Posibilitatea de avansare în cadrul companiei;</li>
              </ul>
            </div>
          </div>
        </div>
        <strong class="d-block mb-3">
          Cei interesați sunt rugați să completeze formularul de mai jos sau să trimită cv-ul pe adresa de mail:
          <a
            href="mailto:radudiafanis@gmail.com"
          >radudiafanis@gmail.com</a>
        </strong>
        <p
          class="mb-4"
        >Persoanele care trec de stadiul de preselectie, vor fi contactate telefonic și invitate la sediul societătii, pentru interviu.</p>
        <h2>Aplică pentru post</h2>
        <ValidationObserver v-slot="{ invalid }" ref="form">
          <form
            method="post"
            ref="jobForm"
            enctype="multipart/form-data"
            @submit.prevent="onSubmit()"
          >
            <div class="row">
              <div class="col-md-6">
                <ValidationProvider
                  class="d-block mb-3"
                  name="nume și prenume"
                  rules="required|alpha_spaces|min:3"
                  :bails="false"
                  v-slot="{ errors, classes }"
                >
                  <label class="d-none" for="name">Nume și prenume</label>
                  <input
                    class="d-block w-100"
                    v-model="name"
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Nume și prenume (obligatoriu)"
                    :class="classes"
                  />
                  <span v-if="errors[0]" ref="errorName" class="d-block error-msg">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider
                  class="d-block mb-3"
                  name="număr de telefon"
                  rules="required|digits:10"
                  :bails="false"
                  v-slot="{ errors, classes }"
                >
                  <label class="d-none" for="phone">Număr de telefon</label>
                  <input
                    class="d-block w-100"
                    v-model="phone"
                    type="tel"
                    name="phone"
                    id="phone"
                    placeholder="Număr de telefon (obligatoriu)"
                    :class="classes"
                  />
                  <span ref="errorPhone" class="d-block error-msg">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider
                  class="d-block mb-3"
                  name="adresa de email"
                  rules="required|email"
                  :bails="false"
                  v-slot="{ errors, classes }"
                >
                  <label class="d-none" for="email">Adresa de email</label>
                  <input
                    class="d-block w-100"
                    v-model="email"
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Adresa de email (obligatoriu)"
                    :class="classes"
                  />
                  <span ref="errorEmail" class="d-block error-msg">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider
                  class="d-block mb-3 file-group"
                  name="încarcă CV-ul tău"
                  ref="file"
                  rules="required"
                  :bails="false"
                  v-slot="{ errors, classes, validate }"
                >
                  <label class="d-block" for="cv">Încarcă CV-ul tău: {{ file.name }}</label>
                  <input
                    class="d-none w-100"
                    @change="handleFileUpload() || validate($event.target.files)"
                    type="file"
                    name="file"
                    id="cv"
                    ref="file"
                    placeholder="Încarcă CV-ul tău (obligatoriu)"
                    :class="classes"
                  />
                  <span ref="errorCv" class="d-block error-msg">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="col-md-12">
                <button class="btn btn-send" type="submit" :disabled="invalid">Trimite mesajul</button>
              </div>
              <div class="col-md-6 offset-md-3" v-if="sent">
                <p class="m-0 text-center success">Ai aplicat cu succes!</p>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>
<script>
const querystring = require("querystring");
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
  configure
} from "vee-validate/dist/vee-validate.full.esm";
import { alpha_spaces } from "vee-validate/dist/rules";
import ro from "vee-validate/dist/locale/ro.json";

// Install and Activate the Romanian locale.
localize("ro", ro);

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
});

export default {
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      file: "",
      sent: false
    };
  },
  methods: {
    onSubmit() {
      var self = this;
      self.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        const form = self.$refs.jobForm;
        let formData = new FormData(form);

        self.$http
          .post("/job.php", formData)
          .then(res => {
            self.sent = true;
            setTimeout(() => {
              self.sent = false;
            }, 5000);
          })
          .catch(error => console.log(error));

        // Resetting Values
        // self.name = self.phone = self.email = self.file = "";
        // self.$nextTick(() => {
        //   self.$refs.form.reset();
        // });

        // setTimeout(() => {
        //   const formElements = self.$refs.jobForm.elements;
        //   const formElementsArr = Array.from(formElements);
        //   formElementsArr.forEach(el => {
        //     console.log(el);
        //     el.classList.remove("touched", "dirty", "is-invalid", "validated", "failed");
        //     el.classList.add("untouched", "pristine");
        //   });
        //   console.log(self.$refs.form.errors);
        // }, 0);
        setTimeout(() => {
          self.$router.go();
        }, 5000);
      });
    },
    handleFileUpload($event) {
      var self = this;
      self.file = event.target.files[0];
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";

.page-careers {
  .page-inner {
    background-color: $white;
  }
  .intro {
    font-size: 1.125rem;
  }
  h2 {
    font-size: 1.5rem;
  }
  .unit {
    padding: 1rem;
    h3 {
      position: relative;
      span {
        color: $secondary-color;
        border: 1px solid $secondary-color;
        border-radius: 50%;
        display: inline-block;
        text-align: center;
        line-height: 40px;
        height: 40px;
        width: 40px;
      }
    }
    ul li {
      border-bottom: 1px solid $light-gray;
      margin-bottom: 10px;
      padding: 0 0 10px 20px;
      position: relative;
      &:last-child {
        border: 0;
        margin: 0;
        padding-bottom: 0;
      }
      &:before {
        content: "";
        background-color: $secondary-color;
        border-radius: 50%;
        display: block;
        margin-right: 1rem;
        position: absolute;
        top: 7px;
        left: 0;
        height: 10px;
        width: 10px;
      }
    }
  }
  form {
    input[type="text"],
    input[type="tel"],
    input[type="email"],
    input[type="file"] {
      border: 1px solid darken($dark-gray, 10%);
      border-radius: $round-corners;
      padding: 10px;
      outline: none;
      transition: box-shadow 0.3s ease, border-color 0.3s ease;
      &:focus {
        box-shadow: 0 0 0 3px rgba(darken($dark-gray, 20%), 0.25);
        border-color: darken($dark-gray, 20%);
      }
      &.is-valid {
        border-color: $secondary-color;
        box-shadow: 0 0 0 3px rgba($secondary-color, 0.25);
      }
      &.is-invalid {
        border-color: $primary-color;
        box-shadow: 0 0 0 3px rgba($primary-color, 0.25);
      }
    }
    .error-msg {
      color: $primary-color;
      font-size: 0.875rem;
      padding: 5px 10px;
    }
    .file-group {
      label {
        border: 1px solid $black;
        border-radius: $round-corners;
        background-color: $black;
        color: $white;
        cursor: pointer;
        padding: 10px;
      }
    }
    .btn-send {
      background-color: $black;
      border: 2px solid $black;
      cursor: pointer;
      color: $white;
      padding: 0.8rem 1rem;
      transition: background-color 0.3s ease, color 0.3s ease;
      &:focus {
        outline: none;
        box-shadow: none;
      }
      &:focus,
      &:hover {
        background: none;
        color: $black;
      }
      &[disabled="disabled"] {
        cursor: not-allowed;
        &:hover {
          background: $black;
          color: $white;
        }
      }
    }
    p.success {
      color: $secondary-color;
      font-weight: $medium;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Careers.vue